import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Host, Input, OnDestroy, OnInit} from '@angular/core';
import {Message} from '../../../../../../chat-sdk/src/entities/messages/message';
import {ChatWrapperComponent} from '../chat-wrapper/item';
import {WorkerStore} from '../../../../../../chat-sdk/src/api/worker';
import {Subscription} from 'rxjs';
import {File} from "../../../../entities/file.entity";

@Component({
  selector: 'app-chat-pined-message',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatPinedMessageComponent implements OnInit, OnDestroy {
  @Input() message: Message = null;
  workerStore: WorkerStore = null;

  chatWrapper: ChatWrapperComponent;
  cdr: ChangeDetectorRef;

  subs: Subscription[] = [];

  constructor(
    @Host() chatWrapper: ChatWrapperComponent,
    cdr: ChangeDetectorRef
  ) {
    this.chatWrapper = chatWrapper;
    this.cdr = cdr;
  }

  ngOnInit() {
    console.log({msg: this.message});
    this.workerStore = this.message?.user?.getWorker();

    this.subs.push(this.workerStore?.updateEvent.subscribe(() => {
      this.cdr.detectChanges();
    }));

    this.message.registerOnUpdate((type) => {
      // console.log('message update component', this.message, type);

      this.cdr.detectChanges();
    });
  }

  firstAttachment(): File | null {
    return this.message.content.attachments.length ? this.message.content.attachments[0] : null;
  }

  unPin() {
    this.chatWrapper.appService.appModalService.openConfirmModal({text: 'Открепить сообщение?', cancelText: 'Открепить'}, (res) => {
      if (res) {
        this.chatWrapper.group.unpinMessage(this.message);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subs.length) {
      this.subs.forEach(item => item.unsubscribe());
    }
  }
}
